import { FC } from 'react'

import { Card } from '@joor/design-system'

import { Contact } from 'features/Orders/components/Contacts/Contact'

const BrandContact: FC<{ name: string; email: string }> = ({ name, email }) => (
  <Card title="Brand Contact">
    <Contact key={email} name={name} email={email} />
  </Card>
)
export default BrandContact
